import type { SxProps, Theme } from "@mui/material";

import { theme } from "@/src/theme/theme";
import { heroGradientColors } from "@/src/theme/tokens";

import { HOMEPAGE_CONTAINER_STYLES } from "@/src/pages/consumer/HomePage/homePage.constants";

const INSTRUCTIONS_GRADIENT_BACKGROUND = [
  `radial-gradient(ellipse at 85% 15%, ${heroGradientColors.deep} 0%, transparent 45%)`,
  `radial-gradient(ellipse at 10% 60%, ${heroGradientColors.base} 0%, transparent 40%)`,
  `radial-gradient(ellipse at 35% 45%, ${theme.palette.brand.secondary} 0%, transparent 38%)`,
  `radial-gradient(ellipse at 72% 78%, ${heroGradientColors.mid} 0%, transparent 35%)`,
  `radial-gradient(ellipse at 60% 20%, ${heroGradientColors.card} 0%, transparent 35%)`
].join(", ");

export const MOBILE_GRID_ITEM_SX: SxProps<Theme> = {
  mb: 2,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "@media (max-width: 699px)": {
    flexBasis: "100%",
    maxWidth: "100%"
  }
};

export const instructionsRootSx: SxProps<Theme> = {
  backgroundColor: heroGradientColors.mid,
  backgroundImage: INSTRUCTIONS_GRADIENT_BACKGROUND,
  position: "relative",
  ...HOMEPAGE_CONTAINER_STYLES,
  px: 0,
  py: 0
};

export const instructionsContainerSx: SxProps<Theme> = {
  ...HOMEPAGE_CONTAINER_STYLES
};

export const instructionsContentSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: ["column", "column", "row"],
  backgroundSize: "45% auto",
  backgroundPosition: "right bottom",
  backgroundRepeat: "no-repeat",
  justifyContent: "space-between"
};

export const instructionsTitleSx: SxProps<Theme> = {
  color: theme.palette.semantic.primary.contrastText
};

export const instructionsListSx: SxProps<Theme> = {
  ul: {
    listStyle: "none",
    paddingLeft: 0,
    maxWidth: ["auto", "auto", "90%"],
    li: {
      display: "flex",
      flexDirection: ["row-reverse", "row"],
      color: theme.palette.semantic.primary.contrastText,
      alignItems: "center",
      marginBottom: 4,
      whiteSpace: "pre-wrap"
    }
  }
};

export const instructionsBulletSx: SxProps<Theme> = {
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  backgroundPosition: "center",
  width: "84px",
  height: "89px",
  flexShrink: 0,
  marginRight: [0, 2],
  marginLeft: [2, 0]
};

export const instructionsListItemTextSx: SxProps<Theme> = {
  maxWidth: ["750px", "auto", "100%"]
};

export const instructionsDividerSx: SxProps<Theme> = {
  display: ["none", "none", "flex"],
  border: `1px solid ${theme.palette.action.disabledBackground}`,
  mr: 5
};

export const instructionsDesktopCtaSectionSx: SxProps<Theme> = {
  display: ["none", "none", "flex"],
  flexDirection: "column",
  alignContent: "center",
  justifyContent: "center"
};

export const instructionsDesktopCtaTitleSx: SxProps<Theme> = {
  width: ["auto", "auto", "max-content"],
  color: theme.palette.semantic.primary.contrastText,
  pb: 2,
  ml: 1
};

export const instructionsMobileSectionSx: SxProps<Theme> = {
  display: ["flex", "flex", "none"],
  backgroundImage: `-webkit-linear-gradient(280deg, ${theme.palette.misc.coldBackground}, ${theme.palette.background.paper})`
};

export const instructionsMobileContentSx: SxProps<Theme> = {
  width: "100%",
  ...HOMEPAGE_CONTAINER_STYLES
};

export const instructionsMobileTitleSx: SxProps<Theme> = {
  pb: 2
};
